const Section5 = () => {
  return (
    <div className="sm:p-[50px] lg:p-[200px]">
      <h2 className="text-3xl p-10 font-light ">Let's Talk</h2>
      <p className="text-xl p-10 pt-0 text-left font-light">
        Get in touch today to schedule and reserve your stay, or if you’re
        already in Puerto Vallarta, we can arrange a house viewing with our
        House Manager. We look forward to hearing from you and answering any
        questions.
      </p>
      <a href="/contact">
        <button className="bg-six pl-10 pr-10 pt-4 pb-4 tracking-widest  text-white text-xl  home-btn">
          GET IN TOUCH
        </button>
      </a>
    </div>
  );
};

export default Section5;
